import React from "react";
import {
  Container,
  Box,
  Grid,
  Typography,
  List,
  ListItem,
} from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import * as images from "./icons";
import "./style.css";

const Footer = () => {
  const classes = useStyles();

  const goto = (link: string, self = false) => {
    const param = `http://${link}`;
    window.open(param, `${self && "_self"}`);
  };

  return (
    <Container className="footer">
      {/* @ts-ignore */}
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        style={{ transform: "translateY(-50%)" }}
      >
        {/* @ts-ignore */}
        <Box display={"flex"}>
          {/* <img
            src={images.telegram}
            alt=""
            width={"25px"}
            style={{ margin: "0px 5px" }}
            className={"dyIcon"}
          /> */}
          <a
            href="http://instagram.com/eniac.tech"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={images.insta}
              alt=""
              width={"25px"}
              style={{ margin: "0px 5px" }}
              className={"dyIcon"}
            />
          </a>

          {/* <img
            src={images.twitter}
            alt=""
            width={"25px"}
            style={{ margin: "0px 5px" }}
            className={"dyIcon"}
          /> */}
          <a
            href="https://www.linkedin.com/company/eniac-tech/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={images.linkdin}
              alt=""
              width={"25px"}
              style={{ margin: "0px 5px" }}
              className={"dyIcon"}
            />
          </a>
        </Box>
        <div className={classes.border}></div>
        <div>
          <img src={images.eniac} alt="" className="eniacIcon" />
        </div>
      </Box>

      {/* @ts-ignore */}
      <Grid container spacing={2} style={{ direction: "rtl" }}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            {/* <Grid item xs={12} md={4}>
              <Typography variant="h6">درباره ما</Typography>
              <List className="footerItem">
                <ListItem
                  component="a"
                  href="#"
                  style={{ paddingRight: "0px" }}
                >
                  هپی شارژ
                </ListItem>
                <ListItem
                  component="a"
                  href="#"
                  style={{ paddingRight: "0px" }}
                >
                  گالری عکس
                </ListItem>
              </List>
            </Grid> */}
            <Grid item xs={12} md={12}>
              <Typography variant="h6" style={{ paddingBottom: "10px" }}>
                تماس با ما
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6} style={{ padding: "5px" }}>
                  <Typography>
                    پشتیبانی: <span>02184226</span>
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ padding: "5px" }}>
                  <Typography>
                    فکس: <span>02188360014</span>
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ padding: "5px" }}>
                  <Typography>
                    تلفن: <span>02181074</span>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} style={{ padding: "5px" }}>
                  <Typography>ایمیل: voucher@eniac-tech.com</Typography>
                  {/* <Typography className="footer-email">
                    voucher@eniac-tech.com
                  </Typography> */}
                </Grid>
              </Grid>

              <Typography
                style={{
                  // marginRight: "20px",
                  fontSize: "14px",
                  // fontWeight: "bold",
                  marginTop: "10px",
                }}
              >
                آدرس: تهران - شهرک غرب - بلوار پاکنژاد نرسیده به تقاطع دریا کوی
                اردیبهشت - ساختمان شماره 23
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              {/* <Typography style={{ textAlign: "center" }}>
                دانلود اپ هپی
              </Typography> */}
              <Grid container spacing={2} style={{ textAlign: "center" }}>
                <Grid item xs={12}>
                  <a href="http://app.eniac-tech.com">
                    <img
                      src={images.downloadIcon}
                      alt=""
                      width={"auto"}
                      height={"40%"}
                      className="mt-2"
                    />
                  </a>
                </Grid>
                {/* <Grid item xs={6}>
                  <a href="http://app.eniac-tech.com">
                    <img
                      src={images.appStore}
                      alt=""
                      width={"80%"}
                      className="mt-2"
                    />
                  </a>
                </Grid> */}
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <a 
                  referrerPolicy='origin' 
                  target='_blank' 
                  href='https://trustseal.enamad.ir/?id=452663&Code=Yy3TGJTcQNxXQLaar0Vfrm5c5u0xdJ3D'>
                    <img 
                    referrerPolicy='origin' 
                    src='https://trustseal.enamad.ir/logo.aspx?id=452663&Code=Yy3TGJTcQNxXQLaar0Vfrm5c5u0xdJ3D' 
                    alt='' 
                    style={{ cursor: "pointer", width: "90px" }}
                    id='Yy3TGJTcQNxXQLaar0Vfrm5c5u0xdJ3D'
                    />
                  </a>
                </Grid>
                <Grid item xs={4}>
                  <img src={images.logo2} alt="" width={"90px"} />
                </Grid>
                <Grid item xs={4}>
                  <img src={images.logo3} alt="" width={"80px"} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item xs={12}>
            <Typography
              style={{
                marginRight: "20px",
                fontSize: "14px",
                fontWeight: "bold",
                marginTop: "10px",
              }}
            >
              آدرس: تهران - شهرک غرب - بلوار پاکنژاد نرسیده به تقاطع دریا کوی
              اردیبهشت - ساختمان شماره 23
            </Typography>
          </Grid> */}
        </Grid>
      </Grid>
      {/* @ts-ignore */}
      <Box className="copy-right">
        <Typography>
          .تمام حقوق این سایت برای شرکت{" "}
          <a
            href="http://eniac-tech.com"
            style={{ color: "black" }}
            className="text-decoration-underline"
          >
            فناوران انیاک
          </a>{" "}
          محفوظ است
        </Typography>
      </Box>
    </Container>
  );
};

export default Footer;

const useStyles = makeStyles((theme: Theme) => ({
  border: {
    width: "100%",
    height: "1px",
    backgroundColor: "#c5c5c5",
    margin: "0px 10px",
  },
  borderDetail: {
    width: "100px",
    height: "1px",
    backgroundColor: "#031fae",
    margin: "5px 0px",
    marginLeft: "auto",
  },
  column: {
    display: "flex",
    flexDirection: "column",
  },
}));
